"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loading = exports.initialLoadingState = exports.reset = exports.fail = exports.finish = exports.start = void 0;
var action_1 = require("./action");
Object.defineProperty(exports, "start", { enumerable: true, get: function () { return action_1.start; } });
Object.defineProperty(exports, "finish", { enumerable: true, get: function () { return action_1.finish; } });
Object.defineProperty(exports, "fail", { enumerable: true, get: function () { return action_1.fail; } });
Object.defineProperty(exports, "reset", { enumerable: true, get: function () { return action_1.reset; } });
var reducer_1 = require("./reducer");
Object.defineProperty(exports, "initialLoadingState", { enumerable: true, get: function () { return reducer_1.initialState; } });
Object.defineProperty(exports, "loading", { enumerable: true, get: function () { return reducer_1.reducer; } });
